'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const LeaveFeedbackIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="LeaveFeedback">
      <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_276_2451)">
          <path
            d="M9.5 7.5H5.667C5.22488 7.5 4.80088 7.67563 4.48825 7.98825C4.17563 8.30088 4 8.72488 4 9.167V20.5"
            stroke={sx?.color || '#3D517B'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path d="M21 20.5V14" stroke={sx?.color || '#3D517B'} strokeLinecap="round" strokeLinejoin="round" />
          <path
            d="M24 20.5C24 21.2956 23.6839 22.0587 23.1213 22.6213C22.5587 23.1839 21.7956 23.5 21 23.5H4C3.20435 23.5 2.44129 23.1839 1.87868 22.6213C1.31607 22.0587 1 21.2956 1 20.5H24Z"
            stroke={sx?.color || '#3D517B'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M20 8C20 8.53043 19.7893 9.03914 19.4142 9.41421C19.0391 9.78929 18.5304 10 18 10C17.4696 10 16.9609 9.78929 16.5858 9.41421C16.2107 9.03914 16 8.53043 16 8H20Z"
            stroke={sx?.color || '#3D517B'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M17.933 0.500001C17.1433 0.502644 16.362 0.662366 15.6346 0.969867C14.9072 1.27737 14.2482 1.7265 13.6961 2.29113C13.1439 2.85575 12.7096 3.52457 12.4184 4.25866C12.1272 4.99274 11.985 5.77742 12 6.567C11.955 7.68327 12.2257 8.78962 12.781 9.759L11 13.5L14.741 11.718C15.5385 12.2124 16.4398 12.5149 17.3741 12.6019C18.3083 12.6889 19.25 12.5578 20.1251 12.2191C21.0001 11.8804 21.7846 11.3433 22.4168 10.6499C23.049 9.95663 23.5117 9.12606 23.7685 8.22359C24.0253 7.32112 24.0692 6.37137 23.8967 5.44907C23.7242 4.52677 23.34 3.65708 22.7743 2.90845C22.2087 2.15981 21.4771 1.55264 20.637 1.13472C19.7969 0.7168 18.8713 0.499528 17.933 0.500001Z"
            stroke={sx?.color || '#3D517B'}
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M15.75 5C15.6119 5 15.5 4.88807 15.5 4.75C15.5 4.61193 15.6119 4.5 15.75 4.5"
            stroke={sx?.color || '#3D517B'}
          />
          <path
            d="M15.75 5C15.8881 5 16 4.88807 16 4.75C16 4.61193 15.8881 4.5 15.75 4.5"
            stroke={sx?.color || '#3D517B'}
          />
          <path
            d="M20.25 5C20.1119 5 20 4.88807 20 4.75C20 4.61193 20.1119 4.5 20.25 4.5"
            stroke={sx?.color || '#3D517B'}
          />
          <path
            d="M20.25 5C20.3881 5 20.5 4.88807 20.5 4.75C20.5 4.61193 20.3881 4.5 20.25 4.5"
            stroke={sx?.color || '#3D517B'}
          />
        </g>
        <defs>
          <clipPath id="clip0_276_2451">
            <rect width="24" height="24" fill="white" transform="translate(0.5)" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

LeaveFeedbackIcon.propTypes = {
  sx: PropTypes.object
}
